import CommonCRUD from "modules/CommonCRUD";
import { CANCELLED } from "constants/orderStatuses";

class OrdersCosts extends CommonCRUD {
    async change(orderId, info) {
        const { id, ...rest } = info;
        return await this.api.fetch({
            method: "post",
            url: `/${this.schema}/change`,
            data: { order_id: orderId, ...rest },
        });
    }
    async changeOrderStatus(orderId, statusId) {
        return await this.api.fetch({
            method: "post",
            url: "/orders/change_provider_status",
            data: {
                order_id: orderId,
                status_id: statusId,
            }, // , edit_reason: editReason //, edit_comment: editReason
        });
    }
}

export default OrdersCosts;
